import { useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import { useAuth } from "../context/authContext";
import { t } from "i18next";
import "./Login.scss";
import { Button, TextBox } from "devextreme-react";
import { TextBoxRef } from "devextreme-react/cjs/text-box";
import { Card } from "../../../core/components";

export default function Login() {
    const navigate = useNavigate();
    const { signIn } = useAuth();
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')

    const usernameInput = useRef<TextBoxRef>(null)
    const passwordInput = useRef<TextBoxRef>(null)

    const login = useCallback(
        async () => {

            setLoading(true);

            const usernameValue = username || usernameInput.current?.instance().option("value") || ""
            const passwordValue = password || passwordInput.current?.instance().option("value") || ""


            const result = await signIn(usernameValue, passwordValue);
            if (!result.isOk) {
                setLoading(false);
                notify(result.message, "error", 2000);
            } else {
                navigate("/dashboard");
            }
        }, [signIn, navigate]
    );

    return (
        <div className="login-container">
            <Card className="login-card">
                <img src="care4check_logo.png" alt="" />
                <span className="login-header font-lato">Login to Care4Check</span>
                <TextBox
                    ref={usernameInput}
                    stylingMode="outlined"
                    disabled={loading}
                    labelMode="floating"
                    label={t("Login")}
                    value={username}
                    style={{width: '100%'}}
                    onValueChange={e => setUsername(e)}
                    mode="email" />
                <TextBox
                    ref={passwordInput}
                    stylingMode="outlined"
                    disabled={loading}
                    labelMode="floating"
                    label={t("Password")}
                    value={password}
                    style={{width: '100%'}}
                    onValueChange={e => setPassword(e)}
                    mode="password" />
                <Button
                    className="login-button border-radius-medium"
                    height={45}
                    type="default"
                    disabled={loading}
                    onClick={e => login()}>
                    <LoadIndicator visible={loading} />
                    <span className="login-button-text">{t("LoginVerb")}</span>
                </Button>
            </Card>
        </div>
    );
}
